import React from "react";
import air_flow_sensor from "../../../../../assets/image/category/air_flow_sensor.jpeg";
import knock_sensor from "../../../../../assets/image/category/knock_sensor.jpeg";
import lambda_sensor from "../../../../../assets/image/category/lambda_sensor.jpeg";
import engine_oil from "../../../../../assets/image/category/engine_oil.jpeg";
import { Link } from "react-router-dom";
export default function ShippingAddress() {
  return (
    <div className="">
      <div className="w-full md:pl-4 md:mt-0">
        <h2 className="text-blue-900 font-extrabold lg:text-2xl md:text-2xl text-2xl mb-2">
          Shipping address
        </h2>
        {/* View Order Table */}
        <div className="w-full">
          <form className="space-y-4">
            <div>
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="firstName"
              >
                First name <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                type="text"
                id="firstName"
                value="Animesh"
              />
            </div>
            <div>
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="lastName"
              >
                Last name <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                type="text"
                id="lastName"
                value="Giri"
              />
            </div>
            <div>
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="companyName"
              >
                Company name (optional)
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                type="text"
                id="companyName"
              />
            </div>
            <div>
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="country"
              >
                Country / Region <span className="text-red-500">*</span>
              </label>
              <select
                className="w-full border border-gray-300 p-2 rounded"
                id="country"
              >
                <option>India</option>
              </select>
            </div>
            <div>
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="streetAddress"
              >
                Street address <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                type="text"
                id="streetAddress"
                value="713, Rawali Mahood, Brahamput"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="town">
                Town / City <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                type="text"
                id="town"
                value="Bahadrabaad"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="city">
                Town / City <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                type="text"
                id="city"
                value="Haridwar"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="state">
                State <span className="text-red-500">*</span>
              </label>
              <select
                className="w-full border border-gray-300 p-2 rounded"
                id="state"
              >
                <option>Uttarakhand</option>
              </select>
            </div>
            <div>
              <label
                className="block text-sm font-medium mb-1"
                htmlFor="pinCode"
              >
                PIN Code <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                type="text"
                id="pinCode"
                value="249402"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="phone">
                Phone <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                type="text"
                id="phone"
                value="06393859228"
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1" htmlFor="email">
                Email address <span className="text-red-500">*</span>
              </label>
              <input
                className="w-full border border-gray-300 p-2 rounded"
                type="email"
                id="email"
                value="animesh@trigya.co"
              />
            </div>
            <div>
              <button
                className="bg-blue-600 text-white px-4 py-2 rounded"
                type="submit"
              >
                Save address
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
